(function(){
  if (window.__ljHome) return; window.__ljHome = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.documentElement.classList.add('lj-anim');

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px' }) : null;
  function scan(scope){ (scope||document).querySelectorAll('.lj-reveal:not(.is-in)').forEach(function(el){ io ? io.observe(el) : el.classList.add('is-in'); }); }
  scan(document);
  document.addEventListener('shopify:section:load', function(e){ scan(e.target); });

  var toast;
  function showToast(msg, ok){
    if (!toast){ toast = document.createElement('div'); toast.className = 'lj-toast'; toast.setAttribute('role','status'); document.body.appendChild(toast); }
    toast.innerHTML = '<span></span>' + (ok ? '<a href="' + root + 'cart">Voir le panier</a>' : '');
    toast.querySelector('span').textContent = msg;
    requestAnimationFrame(function(){ toast.classList.add('is-on'); });
    clearTimeout(toast._t); toast._t = setTimeout(function(){ toast.classList.remove('is-on'); }, 4800);
  }
  function updateCount(count){
    document.querySelectorAll('[data-cart-count],.cart-count,.cart-count-bubble span,.js-cart-count,[data-header-cart-count]').forEach(function(el){ el.textContent = count; el.hidden = false; });
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item_count: count } }));
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-lj-add]'); if (!btn) return;
    e.preventDefault();
    var ids = btn.getAttribute('data-lj-add').split(',').filter(Boolean);
    var label = btn.querySelector('[data-label]'); var initial = label ? label.textContent : '';
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function(id){ return { id: Number(id), quantity: 1 }; }) }) })
    .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; }); })
    .then(function(){ return fetch(root + 'cart.js').then(function(r){ return r.json(); }); })
    .then(function(cart){
      updateCount(cart.item_count);
      btn.classList.add('is-done'); if (label) label.textContent = 'Ajouté ✓';
      showToast((btn.getAttribute('data-lj-name') || 'Votre sélection') + ' est dans votre panier', true);
      setTimeout(function(){ btn.classList.remove('is-done'); if (label) label.textContent = initial; }, 2600);
    })
    .catch(function(err){ showToast(err.message || 'Impossible d’ajouter ce produit pour le moment.', false); })
    .finally(function(){ btn.classList.remove('is-loading'); });
  });
})();
